import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { initializeTheme } from '@/composables/useAppearance';
import AppLayout from '@/layouts/AppLayout.vue';
import AuthLayout from '@/layouts/AuthLayout.vue';
import AuthMinimalLayout from '@/layouts/auth/AuthMinimalLayout.vue';
import CreatorPageLayout from '@/layouts/CreatorPageLayout.vue';
import PublicLayout from '@/layouts/PublicLayout.vue';
import SetupLayout from '@/layouts/SetupLayout.vue';
import { initializeFlashToast } from '@/lib/flashToast';
import i18n from '@/i18n';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    layout: (name) => {
        switch (true) {
            case name === 'creators/Show':
                return CreatorPageLayout;
            case name === 'Welcome':
            case name.startsWith('creators/'):
            case name.startsWith('public/'):
            case name.startsWith('landing/'):
                return PublicLayout;
            case name === 'subscriptions/Return':
            case name === 'contributions/Return':
                return AuthMinimalLayout;
            case name === 'MailPreferences':
            case name.startsWith('auth/'):
            case name.startsWith('fans/'):
            case name.startsWith('fan/'):
            case name.startsWith('subscriptions/'):
                return AuthLayout;
            case name.startsWith('creator/setup/'):
                return SetupLayout;
            case name.startsWith('settings/'):
                return AppLayout;
            default:
                return AppLayout;
        }
    },
    setup({ el, App, props, plugin }) {
        // Use localStorage locale if set, otherwise fall back to server locale
        const storedLocale = typeof window !== 'undefined' ? localStorage.getItem('nv:locale') : null;
        if (!storedLocale) {
            const serverLocale = (props.initialPage.props.locale as string) || 'en';
            i18n.global.locale.value = serverLocale;
        }

        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n);

        if (el) {
            app.mount(el);
        }

        return app;
    },
    progress: {
        color: '#4B5563',
    },
});

if (typeof window !== 'undefined') {
    // This will set light / dark mode on page load...
    initializeTheme();

    // This will listen for flash toast data from the server...
    initializeFlashToast();
}
